import { render, staticRenderFns } from "./DepartmentTeamForm.vue?vue&type=template&id=386d9c06"
import script from "./DepartmentTeamForm.vue?vue&type=script&lang=js"
export * from "./DepartmentTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports